// Doubled so Habla's own rule cannot win on emit order.
.dropdown.dropdown {
  max-height: 300px;
  overflow: auto;
}

.item {
  gap: var(--dixa-size-spacer-300);
  padding: var(--dixa-size-spacer-250) var(--dixa-size-spacer-300);
}
